import Vue from 'vue'
import VueRouter from 'vue-router'
import * as guards from '@/router/guards'

// Routes
import RoutesUsers from './routes/users'
import RoutesPatients from './routes/patients'
import RoutesSurgeons from './routes/surgeons'
import RoutesDistributors from './routes/distributors'
import RoutesDashboard from './routes/dashboard'
import RoutesOperations from './routes/operations'
import RoutesSettings from './routes/settings'
import RoutesHospitals from './routes/hospitals'
import RoutesNurses from './routes/nurses'
import RoutesRayproAdmin from './routes/raypro_admin'
import RoutesHospitalAdmin from './routes/hospital_admin'
import RoutesModerator from './routes/moderator'
import RoutesQuestionnaire from './routes/questionnaire'
import RoutesClinical from './routes/clinical'

// Pages
import Login from '@/components/pages/Login/Login_v2'
import ReceivedMessages from '@/components/pages/Messages/ReceivedMessages'
import SentMessages from '@/components/pages/Messages/SentMessages'
import ComposeMessage from '@/components/pages/Messages/ComposeMessage'
import ConfirmEmail from '@/components/pages/ConfirmEmail'
import ResetPasswordForm from '@/components/pages/Password/ForgotPasswordForm'
import ResetPasswordEmail from '@/components/pages/Password/ForgotPasswordEmail'
import UnsubDelete from '@/components/pages/Delete/UnsubDelete'
// import Registration from '@/components/pages/Registration/Registration'
import PresenterView from '@/components/pages/PresenterView/PresenterView'
import LicenseExpired from '@/components/pages/LicenseExpired'

import store from '@/store/'
import * as websiteTypes from 'raypro_ui/src/store/modules/website/types'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta: {
      requiresAuth: false,
      requiresLoggedOut: true
    }
  },
  {
    path: '/registration',
    component: Login,
    name: 'Registration',
    meta: {
      breadcrumb: 'Register an account',
      requiresAuth: false
    }
  },
  {
    path: '/license-expired',
    component: LicenseExpired,
    name: 'License Expired',
    meta: {requiresAuth: true}
  },
  {
    path: '/confirm_email/:token',
    component: ConfirmEmail,
    meta: {requiresAuth: false}
  },
  {
    path: '/forgot_password/:token?',
    component: ResetPasswordForm,
    name: 'Reset Password From Login',
    meta: {requiresAuth: false}
  },
  {
    path: '/reset_password_email',
    component: ResetPasswordEmail,
    name: 'Reset Password Login Email',
    meta: {requiresAuth: false}
  },
  {
    path: '/delete-own-account/:userId',
    component: UnsubDelete,
    name: 'Unsubscribe Delete',
    meta: {
      requiresAuth: false,
      hideSidebar: true
    }
  },
  {
    path: '/compose-message',
    component: ComposeMessage,
    name: 'Compose Message',
    meta: {
      breadcrumb: 'Compose message',
      requiresAuth: true
    }
  },
  {
    path: '/sent-messages',
    component: SentMessages,
    name: 'Sent Messages',
    meta: {
      breadcrumb: 'Sent messages',
      requiresAuth: true
    }
  },
  {
    path: '/messages',
    component: ReceivedMessages,
    name: 'Received Messages',
    props: true,
    meta: {
      breadcrumb: 'Messages',
      requiresAuth: true
    }
  },
  {
    path: '/presenter-view',
    component: PresenterView,
    name: 'Presenter View',
    meta: {
      requiresAuth: true,
      hideSidebar: true,
      hideNavigation: true,
      fullscreen: true
    }
  },

  // Include Routes
  RoutesUsers,
  RoutesPatients,
  RoutesSurgeons,
  RoutesDashboard,
  RoutesOperations,
  RoutesSettings,
  RoutesHospitals,
  RoutesNurses,
  RoutesRayproAdmin,
  RoutesHospitalAdmin,
  RoutesModerator,
  RoutesQuestionnaire,
  RoutesDistributors,
  RoutesClinical
]

const router = new VueRouter({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes,
  scrollBehavior() {
    return {x: 0, y: 0}
  }
})

router.beforeEach(guards.authGuard)
router.beforeEach(guards.loginGuard)

router.beforeEach((to, from, next) => {
  store.commit(websiteTypes.LAST_URL, from.path)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js